export default function Footer() {
  return (
    <div className='flex flex-row sm:flex-nowrap flex-wrap-reverse sm:text-base text-xs h-12 space-x-1 w-full bg-[#1E2248] text-white justify-center font-light text-center mt-4'>
      <span className='self-center'>Copyright 2023</span>
      <span className='self-center'>-</span>
      <a
        target='_blank'
        rel='noreferrer noopener'
        className='!text-white self-center underline'
        href='https://hapni.fr/mentions-legales/'
      >
        Mentions légales
      </a>
      <span className='self-center'>-</span>
      <a
        target='_blank'
        rel='noreferrer noopener'
        className='!text-white self-center underline'
        href='https://hapni.fr/conditions-generales-dutilisation/'
      >
        CGU
      </a>
      <span className='self-center'>-</span>
      <a
        target='_blank'
        rel='noreferrer noopener'
        className='!text-white self-center underline'
        href='https://hapni.fr/politique-de-confidentialite/'
      >
        Politique de confidentialité
      </a>
    </div>
  );
}
